export default __webpack_public_path__ + "static/media/sounds/tqvm_practice_screen_ready_state_Alyx.mp3";